import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'v_line',
} as IModuleProps;
